import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { fetchModelCurrencyOverview } from "@/services/adminModelCurrency";
import { summaryLine } from "./helpers";

/** Dashboard summary. Fails soft: any error becomes a short message, never a broken dashboard. */
const ModelCurrencySummaryCard = () => {
  const navigate = useNavigate();
  const [line, setLine] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchModelCurrencyOverview()
      .then(overview => {
        if (!cancelled) setLine(summaryLine(overview));
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-4">
          <div>
            <CardTitle>Model Currency</CardTitle>
            <CardDescription>
              {failed ? "Couldn't load model status right now." : (line ?? "Loading…")}
            </CardDescription>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate("/recruit-admin/model-currency")}
          >
            Open model currency
          </Button>
        </div>
      </CardHeader>
      <CardContent className="hidden" />
    </Card>
  );
};

export default ModelCurrencySummaryCard;
